import { render, staticRenderFns } from "./SegmentFoodGroupCards.vue?vue&type=template&id=6d8fdff2&"
import script from "./SegmentFoodGroupCards.vue?vue&type=script&lang=js&"
export * from "./SegmentFoodGroupCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports